const actions = {
    PRODUCT_DETAILS_START: 'PRODUCT_DETAILS_START',
    PRODUCT_DETAILS_SUCCESS: 'PRODUCT_DETAILS_SUCCESS',
    PRODUCT_DETAILS_FAILURE: 'PRODUCT_DETAILS_FAILURE',

    CATALOGUE_DETAILS_START: 'CATALOGUE_DETAILS_START',
    CATALOGUE_DETAILS_SUCCESS: 'CATALOGUE_DETAILS_SUCCESS',
    CATALOGUE_DETAILS_FAILURE: 'CATALOGUE_DETAILS_FAILURE',

    CATEGORY_DETAILS_START: 'CATEGORY_DETAILS_START',
    CATEGORY_DETAILS_SUCCESS: 'CATEGORY_DETAILS_SUCCESS',
    CATEGORY_DETAILS_FAILURE: 'CATEGORY_DETAILS_FAILURE',


    CLIENT_PRODUCT_CATALOGUE_DETAILS_START: 'CLIENT_PRODUCT_CATALOGUE_DETAILS_START',
    CLIENT_PRODUCT_CATALOGUE_DETAILS_SUCCESS: 'CLIENT_PRODUCT_CATALOGUE_DETAILS_SUCCESS',
    CLIENT_PRODUCT_CATALOGUE_DETAILS_FAILURE: 'CLIENT_PRODUCT_CATALOGUE_DETAILS_FAILURE',

    CLIENT_PRODUCT_CATEGORY_DETAILS_START: 'CLIENT_PRODUCT_CATEGORY_DETAILS_START',
    CLIENT_PRODUCT_CATEGORY_DETAILS_SUCCESS: 'CLIENT_PRODUCT_CATEGORY_DETAILS_SUCCESS',
    CLIENT_PRODUCT_CATEGORY_DETAILS_FAILURE: 'CLIENT_PRODUCT_CATEGORY_DETAILS_FAILURE',

    BRAND_DETAILS_START: 'BRAND_DETAILS_START',
    BRAND_DETAILS_SUCCESS: 'BRAND_DETAILS_SUCCESS',
    BRAND_DETAILS_FAILURE: 'BRAND_DETAILS_FAILURE',

    PROVIDER_DETAILS_START: 'PROVIDER_DETAILS_START',
    PROVIDER_DETAILS_SUCCESS: 'PROVIDER_DETAILS_SUCCESS',
    PROVIDER_DETAILS_FAILURE: 'PROVIDER_DETAILS_FAILURE',

    PLAN_DETAILS_START: 'PLAN_DETAILS_START',
    PLAN_DETAILS_SUCCESS: 'PLAN_DETAILS_SUCCESS',
    PLAN_DETAILS_FAILURE: 'PLAN_DETAILS_FAILURE',

    CLEAR_ADMIN_PRODUCT_DETAILS_START: 'CLEAR_ADMIN_PRODUCT_DETAILS_START',
    CLEAR_ADMIN_PRODUCT_DETAILS_SUCCESS: 'CLEAR_ADMIN_PRODUCT_DETAILS_SUCCESS'
};

export default actions;